import { createContext } from "react";

export type OpenDrop = {
  id: string,
  status: boolean
}

export type NavbarContextProps = {
  isFade: boolean,
  setIsFade: (value: boolean) => void,
  open: OpenDrop | undefined,
  setOpen: (value: OpenDrop | undefined) => void
}

const defaultContext = {
  isFade: false,
  open: undefined,
  setOpen: () => {},
  setIsFade: () => {},
};

export const NavbarContext = createContext<NavbarContextProps>(defaultContext);

export default NavbarContext;
